import qs from 'qs'
import { i18n } from '../locales'

export const requestClient = async (...rest: Parameters<typeof fetch>) => {
  const res = await fetch(...rest)
  return res.json()
}

export interface ApprowResponse<T = any> {
  code: number
  message?: string
  data?: T
}

requestClient.get = async <T>(
  path: string,
  query: Record<string, any> = {},
  init?: RequestInit
): Promise<ApprowResponse<T>> => {
  const res = await fetch(
    `${requestClient.baseUrl}${path}${qs.stringify(query, {
      addQueryPrefix: true,
    })}`,
    {
      ...init,
      headers: {
        ...init?.headers,
        [requestClient.langHeader]: i18n.language,
      },
    }
  )

  return res.json()
}

requestClient.post = async <T>(
  path: string,
  data: any,
  config?: {
    headers: any
  }
): Promise<ApprowResponse<T>> => {
  const res = await fetch(`${requestClient.baseUrl}${path}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      ...config?.headers,
      'Content-Type': 'application/json',
      [requestClient.langHeader]: i18n.language,
    },
  })
  return res.json()
}

requestClient.baseUrl = ''
requestClient.setBaseUrl = (base: string) => {
  requestClient.baseUrl = base.replace(/\/$/, '')
}

const DEFAULT_LANG_HEADER = 'x-approw-lang'
requestClient.langHeader = DEFAULT_LANG_HEADER
requestClient.setLangHeader = (key: string | undefined) => {
  requestClient.langHeader = key || DEFAULT_LANG_HEADER
}
